import { StepAction } from './stepAction';

export class ExtensionOnlyStepAction extends StepAction {
    override async performAction() {
        return {
            success: 'skipped',
            reason: 'This step can run only in ‘extension’ run mode with either Chrome or Edge Chromium',
        };
    }
}
